import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ip-whitelist" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  class: "data",
  relative: ""
}
const _hoisted_4 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TextArea = _resolveComponent("TextArea")
  const _component_Loader = _resolveComponent("Loader")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["SettingsIcon"], {
      class: "icon",
      disabled: $data.loading
    }, null, 8 /* PROPS */, ["disabled"]),
    _createElementVNode("div", {
      class: "info",
      disabled: $data.loading
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("b", null, "IP Whitelist:", -1 /* HOISTED */)
    ]), 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_TextArea, {
        modelValue: $data.data,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.data) = $event)),
        modelModifiers: { trim: true },
        disabled: $data.loading,
        maxlength: 100000,
        class: "textarea",
        placeholder: "118.226.82.231/32\n10.0.0.0/8\n172.16.0.0/16"
      }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
      ($data.loading)
        ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", {
      class: "action",
      disabled: $data.loading
    }, [
      _createVNode(_component_Button, {
        primary: "",
        disabled: !$options.can_send,
        onClick: $options.onSave
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode(" Apply Whitelist ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"]),
      _createVNode(_component_Button, {
        disabled: !$data.data,
        plain: "",
        onClick: $options.onClear
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" Remove Whitelist ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"])
    ], 8 /* PROPS */, _hoisted_4)
  ]))
}